export default __webpack_public_path__ + "static/media/08.aa35860f.jpg";